import React, { useState } from 'react';
import { motion } from 'framer-motion';

/**
 * Phones: one continuous diagonal reveal over the whole hero, from the bottom-left corner to the
 * top-right. A white veil sweeps away first; a blur veil trails just behind it, so everything
 * surfaces softly out of focus and sharpens as the front passes — one aligned motion instead of
 * separate elements popping in on their own timings.
 */
const MASK = 'linear-gradient(to top right, transparent 40%, #000 60%)';
const EASE = [0.45, 0, 0.25, 1] as const;
const DURATION = 1.5;
/** How far the sharpening trails the reveal front */
const BLUR_LAG = 0.35;
const maskStyle: React.CSSProperties = {
  WebkitMaskImage: MASK,
  maskImage: MASK,
  WebkitMaskSize: '300% 300%',
  maskSize: '300% 300%',
  WebkitMaskRepeat: 'no-repeat',
  maskRepeat: 'no-repeat'
};
// Window starts on the solid (top-right) end of the gradient and travels to the clear (bottom-left)
// end, so the clear region grows from the bottom-left corner up to the top-right
const FROM = {
  WebkitMaskPosition: '100% 0%',
  maskPosition: '100% 0%'
};
const TO = {
  WebkitMaskPosition: '0% 100%',
  maskPosition: '0% 100%'
};
export function MobileHeroSweep({
  delay = 0.1
}: {
  delay?: number;
}) {
  const [done, setDone] = useState(false);
  if (done) return null;
  return <div aria-hidden="true" className="pointer-events-none absolute inset-0 z-[35] md:hidden" data-id="element-135" data-mp="1f5wvfmbrend8">
      {/* Trailing focus veil: content behind the front is still soft, then sharpens */}
      <motion.div className="absolute inset-0 backdrop-blur-[12px]" style={maskStyle} initial={FROM} animate={TO} transition={{
      duration: DURATION,
      ease: EASE,
      delay: delay + BLUR_LAG
    }} onAnimationComplete={() => setDone(true)} data-id="element-136" data-mp="ndz4s9hati4j" />
      {/* Leading white veil: the reveal front */}
      <motion.div className="absolute inset-0 bg-white" style={maskStyle} initial={FROM} animate={TO} transition={{
      duration: DURATION,
      ease: EASE,
      delay
    }} data-id="element-137" data-mp="22ug5o7edda7y" />
    </div>;
}